export enum ServiceErrorCode {
  AuthRequired = "PROJECT_VIEW_LINK_AUTH_REQUIRED",
  NotFound = "PROJECT_VIEW_LINK_NOT_FOUND",
  InvitationNotFound = "PROJECT_VIEW_LINK_INVITATION_NOT_FOUND",
  Forbidden = "PROJECT_VIEW_LINK_FORBIDDEN",
  InvalidRequestQueryParameter = "INVALID_REQUEST_QUERY_PARAMETER",
  CommentNotFound = "COMMENT_NOT_FOUND",
  CommentingForbidden = "COMMENTING_FORBIDDEN",
}

export const sanitizeRedirectUrl = (url: string): URL => {
  try {
    const urlObject = new URL(url);
    if (window.location.origin === urlObject.origin) {
      return urlObject;
    }
  } catch {
    // We don't care about the error, we just want to make sure that the URL is valid
  }

  return new URL(window.location.origin);
};
